<template>
	<div class="number-list">
		<transaction-chip @clicked="clicked" v-for="t in transactions" :key="t.id" :type="t.transactionType" :trackingNumber="t.trackingNumber"></transaction-chip>
	</div>
</template>

<script>
import transactionChip from "../tracking-chip.vue";

export default {
	props: ["transactions"],
	components: {
		transactionChip,
	},
	data() {
		return {};
	},
	methods: {
		clicked(id) {
			this.$emit("clicked", id);
		},
	},
};
</script>
<style scoped>
.number-list .tracking-number {
	margin: 4px 10px 4px 0;
}
</style>
